"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dragon = void 0;

var _react = _interopRequireWildcard(require("react"));

var _util = require("../util");

var _Video2 = require("./Video");

var _excluded = ["src", "metadata", "autoPlay"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var newRepetitions = 10;
var reviewRepetitions = 2;
var Dragon = {
  Video: function Video(_ref) {
    var src = _ref.src,
        metadata = _ref.metadata,
        autoPlay = _ref.autoPlay,
        props = _objectWithoutProperties(_ref, _excluded);

    src = Object.values(src)[0];
    var videoRef = (0, _react.useRef)();
    var dragonState = Dragon.useState({
      videoRef: videoRef,
      src: src,
      metadata: metadata,
      newRepetitions: newRepetitions,
      reviewRepetitions: reviewRepetitions
    });
    return /*#__PURE__*/_react.default.createElement(_Video2.Video.Container, _extends({
      ref: videoRef
    }, _objectSpread({
      src: src,
      autoPlay: autoPlay
    }, props), {
      absoluteChildren: /*#__PURE__*/_react.default.createElement(Dragon.RepeatBadge, dragonState)
    }), /*#__PURE__*/_react.default.createElement(_Video2.Video.PlayButton, {
      autoPlay: props.autoPlay
    }), /*#__PURE__*/_react.default.createElement(Dragon.TimeBar, dragonState), /*#__PURE__*/_react.default.createElement(_Video2.Video.Loop, null), /*#__PURE__*/_react.default.createElement(_Video2.Video.Fullscreen, null));
  },
  useState: function useState(_ref2) {
    var _Object$values$;

    var videoRef = _ref2.videoRef,
        src = _ref2.src,
        metadata = _ref2.metadata;

    var _useState2 = (0, _react.useState)({
      offset: 0,
      length: 1,
      repeats: newRepetitions
    }),
        _useState3 = _slicedToArray(_useState2, 2),
        repeatState = _useState3[0],
        setRepeatState = _useState3[1];

    var _useState4 = (0, _react.useState)(0),
        _useState5 = _slicedToArray(_useState4, 2),
        curTime = _useState5[0],
        setCurTime = _useState5[1];

    var _useState6 = (0, _react.useState)(0),
        _useState7 = _slicedToArray(_useState6, 2),
        duration = _useState7[0],
        setDuration = _useState7[1];

    var seekToOffset = function seekToOffset(offset) {
      return setRepeatState({
        offset: offset,
        length: 1,
        repeats: newRepetitions
      });
    }; // reset repeat state for new video


    (0, _react.useEffect)(function () {
      seekToOffset(0);
      setCurTime(0);
    }, [src]);
    var timestamps = (_Object$values$ = Object.values(metadata.referencedVideos)[0]) === null || _Object$values$ === void 0 ? void 0 : _Object$values$.timestamps;
    var nextState = Dragon.nextState({
      newRepetitions: newRepetitions,
      reviewRepetitions: reviewRepetitions,
      segmentCount: timestamps === null || timestamps === void 0 ? void 0 : timestamps.length
    });

    var updateTimes = function updateTimes() {
      var _videoRef$current, _videoRef$current2, _videoRef$current3;

      if (((_videoRef$current = videoRef.current) === null || _videoRef$current === void 0 ? void 0 : _videoRef$current.currentTime) >= timestamps[repeatState.offset + repeatState.length]) {
        var newState = nextState(repeatState);
        if (newState.offset != repeatState.offset + repeatState.length) videoRef.current.currentTime = timestamps[newState.offset]; // because it unhelpfully pauses when it hits the end of the video, but we haven't finished looping yet

        if (videoRef.current.paused) videoRef.current.play();
        setRepeatState(nextState);
      }

      setCurTime(((_videoRef$current2 = videoRef.current) === null || _videoRef$current2 === void 0 ? void 0 : _videoRef$current2.currentTime) || 0);
      setDuration(((_videoRef$current3 = videoRef.current) === null || _videoRef$current3 === void 0 ? void 0 : _videoRef$current3.duration) || 0);
    };

    (0, _util.useRefListener)(videoRef, 'loadedmetadata', updateTimes, [src, repeatState]); // init on newly loaded videos

    (0, _util.useRefListener)(videoRef, 'timeupdate', updateTimes, [src, repeatState]); // update state on all timeupdate events

    return _objectSpread(_objectSpread({}, repeatState), {}, {
      setRepeatState: setRepeatState,
      timestamps: timestamps,
      seekToOffset: seekToOffset,
      curTime: curTime,
      duration: duration
    });
  },
  TimeBar: function TimeBar(_ref3) {
    var timestamps = _ref3.timestamps,
        setRepeatState = _ref3.setRepeatState,
        seekToOffset = _ref3.seekToOffset,
        curTime = _ref3.curTime,
        duration = _ref3.duration,
        offset = _ref3.offset,
        length = _ref3.length,
        videoRef = _ref3.videoRef;
    var barRootRef = (0, _react.useRef)();
    var scale = 100 / duration;

    var getSeekTime = function getSeekTime(e) {
      var bar = barRootRef.current;
      var xFraction = (e.clientX - bar.getBoundingClientRect().left) / bar.offsetWidth;
      return xFraction * duration || 0;
    };

    var seek = function seek(e) {
      var seekTime = getSeekTime(e);
      videoRef.current.currentTime = seekTime;

      if (timestamps.length > 0) {
        var _findClosest = (0, _util.findClosest)(timestamps, seekTime, true),
            _findClosest2 = _slicedToArray(_findClosest, 2),
            closestTime = _findClosest2[0],
            index = _findClosest2[1];

        setRepeatState({
          offset: index,
          length: 1,
          repeats: newRepetitions
        });
      }
    };

    var mouseMove = function mouseMove(e) {
      if (e.buttons == 1) {
        seek(e);
      }
    };

    return /*#__PURE__*/_react.default.createElement("div", {
      className: "progressBar",
      ref: barRootRef,
      onMouseMove: mouseMove,
      onTouchMove: seek,
      onClick: seek
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: "bar",
      style: {
        backgroundColor: "#fd4",
        width: timestamps[offset] * scale + "%"
      }
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "bar",
      style: {
        backgroundColor: "#fd44",
        width: timestamps[offset + length] * scale + "%"
      }
    }), timestamps // a star for each future timestamp
    .map(function (t, i) {
      return /*#__PURE__*/_react.default.createElement("span", {
        className: "starMarker",
        key: i,
        style: {
          left: "".concat(t * scale, "%")
        }
      }, i == offset ? '•' : i < offset + length ? '·' : '⟡');
    }), /*#__PURE__*/_react.default.createElement("div", {
      className: "circleMarker",
      style: {
        left: "".concat(scale * curTime, "%")
      }
    }));
  },
  RepeatBadge: function RepeatBadge(_ref4) {
    var repeats = _ref4.repeats;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: "repeatsBadge"
    }, /*#__PURE__*/_react.default.createElement("b", null, repeats), /*#__PURE__*/_react.default.createElement("br", null), "More Times");
  },
  nextState: function nextState(_ref5) {
    var newRepetitions = _ref5.newRepetitions,
        reviewRepetitions = _ref5.reviewRepetitions,
        segmentCount = _ref5.segmentCount;
    return function (_ref6) {
      var offset = _ref6.offset,
          length = _ref6.length,
          repeats = _ref6.repeats;
      // first innermost repeats
      repeats--;
      if (repeats > 0) return {
        offset: offset,
        length: length,
        repeats: repeats
      }; // Done with the full cycle? start at the beginning again.

      if (length >= segmentCount) {
        // TODO: send ending event?
        // loop back to beginning
        return {
          offset: 0,
          length: 1,
          repeats: newRepetitions
        };
      } // if this interval is not aligned in the next size block, and the next block exists
      // then start new material (smallest interval immediately after current one)


      if ((offset + length) % (2 * length) != 0 && offset + length < segmentCount) {
        return {
          offset: offset + length,
          length: 1,
          repeats: newRepetitions
        };
      } // if we are aligned, and we still have room in this module
      // then review (double interval size, end time fixed)


      if (2 * length < segmentCount) {
        return {
          offset: offset - length,
          length: 2 * length,
          repeats: reviewRepetitions
        };
      } // we are ready to review the whole module (interval expands to cover everything)


      blockOffset = {
        measure: 0,
        module: OM + LM
      };
      blockLength = {
        measure: 0,
        module: 1
      };
      return {
        offset: 0,
        length: segmentCount,
        repeats: reviewRepetitions
      };
    };
  }
};
exports.Dragon = Dragon;